import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Delete Avatar Request Schema
 * DELETE /api/v2/avatar
 * Deletes the user's avatar
 */ export const DeleteAvatarRequestSchema = z.object({});
/**
 * Delete Avatar Response Schema
 */ export const DeleteAvatarResponseSchema = z.object({
    success: z.boolean()
});
/**
 * Delete Avatar Error Schema
 */ export const DeleteAvatarErrorSchema = BaseErrorSchema;

//# sourceMappingURL=delete-avatar.schema.js.map